"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceRootMixin = void 0;
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var model_js_1 = require("@cognitoforms/model.js");
var source_root_adapter_1 = require("./source-root-adapter");
var vue_model_observability_1 = require("./vue-model-observability");
// @ts-ignore
var SourceRootMixin = /** @class */ (function (_super) {
    __extends(SourceRootMixin, _super);
    function SourceRootMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SourceRootMixin.prototype.onReadonlyChanged = function (readonly) {
        this.$source.readonly = readonly;
    };
    Object.defineProperty(SourceRootMixin.prototype, "$source", {
        get: function () {
            var entity;
            if (this.source instanceof model_js_1.Entity) {
                entity = this.source;
            }
            else {
                entity = this[this.source || "entity"];
                if (!entity || !(entity instanceof model_js_1.Entity)) {
                    throw new Error("No entity data!");
                }
            }
            (0, vue_model_observability_1.observeEntity)(entity).ensureObservable();
            return new source_root_adapter_1.SourceRootAdapter({ parent: this, propsData: { entity: entity } });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: [Object, String] }),
        __metadata("design:type", Object)
    ], SourceRootMixin.prototype, "source", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Boolean, default: null }),
        __metadata("design:type", Boolean)
    ], SourceRootMixin.prototype, "readonly", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)("readonly"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SourceRootMixin.prototype, "onReadonlyChanged", null);
    SourceRootMixin = __decorate([
        vue_property_decorator_1.Component
    ], SourceRootMixin);
    return SourceRootMixin;
}(vue_1.default));
exports.SourceRootMixin = SourceRootMixin;
